export function shuffle(arr) { //洗牌算法
    let N = arr.length
    for (let i = 0; i < N; i++) {
        let j = Math.floor(Math.random() * N)
        let t = arr[i]
        arr[i] = arr[j]
        arr[j] = t
        //解构赋值报错 [a,b] = [b,a]
    }
}
export function getFileName(fullName){
    let dot = fullName.lastIndexOf('.')
    if(dot !== -1)
        return fullName.substring(0, dot)
    return fullName
}
export function getSuffix(fullName){
    let dot = fullName.lastIndexOf('.')
    if(dot !== -1)
        return fullName.substring(dot)
    return ""
}
export function isMobile(){
    return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    ) != null
}
export function isVerticalScreen(){
    let width = document.documentElement.clientWidth;
    let height = document.documentElement.clientHeight;
    return width < height
}